/**
* Logo Marquee JS
* -----------------------------------------------------------------------------
*
* All the JS for the Logo Marquee component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {

    className: 'logo-marquee',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.logo-marquee__splide' ).each( function( key, component ) {
        const slideList = component.querySelector( '.splide__list' );
        const slides = component.querySelectorAll( '.splide__slide' );

        let totalWidth = 0;
        const containerWidth = component.offsetWidth;

        while ( totalWidth < containerWidth * 2 ) {
          slides.forEach( ( slide ) => {
            const clone = slide.cloneNode( true );
            slideList.appendChild( clone );
            totalWidth += slide.offsetWidth + 42;
          } );
        }

        new Splide( component, {
          type: 'loop',
          pagination: false,
          autoWidth: true,
          focus: 'center',
          drag: false,
          gap: '80px',
          speed: 1000,
          arrows: false,
          autoScroll: {
            speed: 0.75,
            pauseOnHover: false,
          },
        } ).mount( {AutoScroll} );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'logo-marquee', COMPONENT );
} )( app );
